import React, { useState, useEffect } from "react";
import Chart from 'react-apexcharts';
import { Select, Space } from 'antd';

// function DashboardLineChart() {
const DashboardLineChart = ({ chartDataImpressions, chartDataRevenue }) => {
  const [impressions, setImpressions] = useState([]);
  const [clicks, setClicks] = useState([]);
  const [date, setDate] = useState([]);
  const [currentSeries, setCurrentSeries] = useState('ImpressionsvsClicks')

  const handleChange = (value) => {
    // console.log(`selected ${value}`);
    // console.log(value)
    // Revenue
    // ImpressionsvsClicks
    if(value === 'ImpressionsvsClicks') {
      // console.log('ImpressionsvsClicks111111');
      setCurrentSeries('ImpressionsvsClicks');
      const data = chartDataImpressions;
      if(data.length>0) {
        setImpressions(data?.map((item) => item.impressions));
        setClicks(data?.map((item) => item.clicks));
        setDate(data?.map((item) => item.date));
      }
    }else {
      setCurrentSeries('Revenue');
      const data = chartDataRevenue;
      if(data.length>0) {
        setImpressions(data?.map((item) => item.revenue));
        setClicks([]);
        setDate(data?.map((item) => item.date));
      }
    }
  };

  useEffect(() => {
    setTimeout(function(){
      setCurrentSeries('ImpressionsvsClicks');
      const data = chartDataImpressions;
      if(data.length>0) {
        setImpressions(data?.map((item) => item.impressions));
        setClicks(data?.map((item) => item.clicks));
        setDate(data?.map((item) => item.date));
      }
    }, 500);
  },[chartDataImpressions]);

  const impressionSeries = [
    {
      name: "Impressions",
      data: impressions
    },
    {
      name: "Clicks",
      data: clicks
    }
  ];
  const revenueSeries = [
    {
      name: "Revenue",
      data: impressions
    }
  ];
  
  const options1 = {
    chart: {
      id: 'line-chart',
      toolbar: {
        show: false
      },
      zoom: {
        enabled: false,
      }
    },
    grid: {
      show: true,
      borderColor: '#E0E0E0',
      strokeDashArray: 3,
      position: 'back',
      xaxis: {
        lines: {
          show: true
        }
      },  
      yaxis: {
        lines: { 
          show: false
        }
      },
    },
    dataLabels: {
      enabled: false,
    },
    legend: {
      position: 'top',
      labels: {
        colors: '#616161',
        useSeriesColors: false
      },
      markers: {
        width: 14,
        height: 4,
      },
    },
    colors: ["#006acc", "#33b688"],
    stroke: {
      curve: 'smooth',
      width: [2, 2]
    },
    xaxis: {
      type: 'category',
      categories: date,
      position: 'bottom',
      labels: {
        show: true,
        style: {
          colors: '#BDBDBD',
          fontSize: '11px',
          fontFamily: 'Montserrat, sans-serif',
          fontWeight: 500,
          cssClass: 'apexcharts-xaxis-label',
        },
      },
    },
    yaxis: {
      labels: {
        show: false,
      },
    },
    tooltip: {
      enabled: true,
      onDatasetHover: {
          highlightDataSeries: true,
      },
      x: {
          show: true,
          format: 'dd MMM',
          formatter: undefined,
      },
      y: {
          formatter: function(value, { series, seriesIndex, dataPointIndex, w }) {
            return value
          },
          title: {
              formatter: (seriesName) => seriesName,
          },
      },
      marker: {
          show: true,
      },
  }
  };

  const options2 = {
    chart: {
      id: 'line-chart',
      toolbar: {
        show: false
      },
      zoom: {
        enabled: false,
      }
    },
    grid: {
      show: true,
      borderColor: '#E0E0E0',
      strokeDashArray: 3,
      position: 'back',
      xaxis: {
        lines: {
          show: true
        }
      },  
      yaxis: {
        lines: { 
          show: false
        }
      },
    },
    dataLabels: {
      enabled: false,
    },
    legend: {
      position: 'top',
      labels: {
        colors: '#616161',
        useSeriesColors: false
      },
      markers: {
        width: 14,
        height: 4,
      },
    },
    colors: ["#006acc", "#33b688"],
    stroke: {
      curve: 'smooth',
      width: [2, 2]
    },
    xaxis: {
      type: 'category',
      categories: date,
      position: 'bottom',
      labels: {
        show: true,
        style: {
          colors: '#BDBDBD',
          fontSize: '11px',
          fontFamily: 'Montserrat, sans-serif',
          fontWeight: 500,
          cssClass: 'apexcharts-xaxis-label',
        },
      },
    },
    yaxis: {
      labels: {
        show: false,
      },
    },
    tooltip: {
      enabled: true,
      onDatasetHover: {
          highlightDataSeries: true,
      },
      x: {
          show: true,
          format: 'dd MMM',
          formatter: undefined,
      },
      y: {
          formatter: function(value, { series, seriesIndex, dataPointIndex, w }) {
            return '$ '+value
          },
          title: {
              formatter: (seriesName) => seriesName,
          },
      },
      marker: {
          show: true,
      },
  }
  };
  return (
    <div>
      <div className='d-flex justify-content-between mb-3'>
        <div>
          <h2 className="title_heading">Performance</h2>
        </div>
        <div>
          <div className='d-flex gap-8px form_select_container'>
            <Space wrap>
              <Select
                // defaultValue={(currentSeries === 'ImpressionsvsClicks') ? 'Impressions vs. Clicks' : 'Revenue'}
                value={(currentSeries === 'ImpressionsvsClicks') ? 'Impressions vs. Clicks' : 'Revenue'}
                onChange={handleChange}
                className='btn_select form_select w_190px'
                options={[
                { value: 'ImpressionsvsClicks', label: 'Impressions vs. Clicks' },
                { value: 'Revenue', label: 'Revenue' },
                ]}
              />
            </Space>
          </div>
        </div>
      </div>
      <Chart
        options={currentSeries === 'ImpressionsvsClicks' ? options1 : options2}
        series={currentSeries === 'ImpressionsvsClicks' ? impressionSeries : revenueSeries}
        type="line"
        // width="1400"
        height="300"
      />
    </div>
  );
}

export default DashboardLineChart;